import { useState, useEffect, useRef } from 'react';
import './Sidebar.css';
import CustomDropdown from './CustomDropdown';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import { useToken } from '../TokenContext.js';

const Sidebar = ({ sidebarOpen, toggleSidebar, isAdminView, isDarkMode, currentSession, updateSession, queryResponse, username, query}) => {
  const [hoverText, setHoverText] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedSession, setSelectedSession] = useState(null);
  const [selectedOption, setSelectedOption] = useState('All'); // Default selection
  const [dropdownVisibleFor, setDropdownVisibleFor] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedSessionId, setSelectedSessionId] = useState(null);
  const [isEditing, setIsEditing] = useState(false); // To manage edit mode
  const [newSummary, setNewSummary] = useState("");
  const [showOptions, setShowOptions] =useState(false);
  const dropdownRef = useRef(null);
  const confirmationRef = useRef(null);
  const inputRef = useRef(null);
  const chatHistoryListRef = useRef(null);

  Sidebar.propTypes = {
    sidebarOpen: PropTypes.bool.isRequired,
    toggleSidebar: PropTypes.func.isRequired,
    isAdminView: PropTypes.bool.isRequired,
    isDarkMode: PropTypes.bool.isRequired,
    currentSession: PropTypes.object.isRequired,
    updateSession: PropTypes.func.isRequired,
    queryResponse: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    query: PropTypes.string.isRequired,

  };

  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

  const handleMouseEnter = () => {
    setHoverText(sidebarOpen ? 'Close sidebar' : 'Open sidebar');
  };

  const handleMouseLeave = () => {
    setHoverText('');
  };
const token = useToken().token;
  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
    // You can add additional logic here for what happens when the selection changes
  };

  const handleClick = (chat) => {
    //console.log("session clicked", chat);
    updateSession(chat.session_id);
    setSelectedSession(chat.session_id);

  };

  const newSession = () => {
    // Set session ID in state
    //console.log("new session created", uuidv4());
    updateSession(uuidv4());
    setSelectedSession('null');
  };

 // Function to fetch chat history
const fetchChatHistory = async () => {
  setIsLoading(true);
  const email = username;
  const url = new URL('https://infia.enviseer.com/api/llm/sessions');

    try {
      const response = await fetch(url, {
        method: 'POST', // POST method as per your request
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      setChatHistory(data);

      setSelectedSession('null'); // Reset selected session
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching chat history:', error);
      setIsLoading(false);
    }
  };

  const handleIconClick = () => {
    setShowOptions(!showOptions); // Toggle the visibility of the options
  };

// useEffect to fetch chat history when sidebar is open and user is not in admin view
useEffect(() => {
  //console.log("", isLoading);
  if (sidebarOpen && !isAdminView) {
    fetchChatHistory(); // Reuse the function here
    setSelectedSession(currentSession);

  }
}, [sidebarOpen, isAdminView, query, queryResponse]);

// Function to delete chat and refetch history
const handleDeleteChat = async () => {
  try {
    const response = await fetch('https://infia.enviseer.com/api/llm_backend/conversations/delete', {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: username }),
    });

      if (response.ok) {
        const data = await response.json();
        //console.log('Chat deleted successfully:', data);

      // Refetch chat history after successful deletion
      fetchChatHistory(); // Reuse the function here as well
      newSession();
    } else {
      console.error('Failed to delete chat:', response.statusText);
    }
  } catch (error) {
    console.error('Error occurred while deleting chat:', error);
  }
};
const toggleDropdown = (sessionId) => {
  const chatHistoryList = chatHistoryListRef.current;

  if (chatHistoryList) {
    const scrollTop = chatHistoryList.scrollTop; // Get the scroll position
    //console.log("lllllllllllll",scrollTop);

    setDropdownPosition({
      marginTop: -scrollTop, // Adjust marginTop based on scroll
    });
  }
  setDropdownVisibleFor(prev => (prev === sessionId ? null : sessionId));
  //console.log("bbbbbbbbbb");
};

useEffect(() => {
  const handleClickOutside = (event) => {
    // Check if the clicked element is not inside the dropdown
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      toggleDropdown(null); // Close the dropdown
    }

    if (confirmationRef.current && !confirmationRef.current.contains(event.target)) {
      setShowConfirmation(false);
    }
  };

    // Add event listener for clicks
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef, toggleDropdown, confirmationRef]);

  const handleDelete = (sessionId) => {
    setSelectedSessionId(sessionId); // Set the session ID for the selected chat
    setShowConfirmation(sessionId); // Show confirmation dialog
  };
  
const removeChat = async (sessionId) => {
  try {
    const response = await fetch('https://infia.enviseer.com/api/llm_backend/session/delete', {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ session_id: sessionId }),
    });

    const data = await response.json();

    if (response.ok) {
      //console.log(data.message);  // Successfully deleted session
      setChatHistory(prevChats => prevChats.filter(chat => chat.session_id !== sessionId)); // Remove the deleted chat
    } else {
      console.error('Failed to delete the session:', data.message);
    }
  } catch (error) {
    console.error('Error:', error);
  }

  setDropdownVisibleFor(null);  // Close the dropdown after removing
};

const confirmDelete = () => {
  removeChat(selectedSessionId); // Call the removeChat with the selected session_id
  setShowConfirmation(false); // Close the confirmation modal
};  

const handleRename = async (sessionId) => {
  try {
    const response = await fetch('https://infia.enviseer.com/api/llm_backend/conversation_history/update_summary', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        session_id: sessionId,
        summary: newSummary,
      }),
    });

    if (response.ok) {
      setIsEditing(false); // Exit edit mode
      fetchChatHistory();
      //console.log('Summary updated successfully!');
    } else {
      //console.log('Failed to update summary.');
    }
  } catch (error) {
    console.error('Error updating summary:', error);
  }
};

const handleRenameClick = (sessionId, summary) => {
   setIsEditing(sessionId);
   setNewSummary(summary);
}

const handleKeyDown = (e, sessionId) => {
  if (e.key === 'Enter') {
    handleRename(sessionId); // Save the new summary on Enter
  }
};

const handleBlur = (sessionId) => {
  handleRename(sessionId); // Save changes when the input loses focus
};

// Auto-focus input field when it becomes visible
useEffect(() => {
  if (isEditing && inputRef.current) {
    inputRef.current.focus();
  }
}, [isEditing]);


  return (
    <div className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-header">
        <button
          className="toggle-button"
          onClick={toggleSidebar}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <i className="bi bi-layout-sidebar-inset" style={{ color: !isDarkMode ? (sidebarOpen ? '#0b1a5b' : 'white') : 'white' }}></i>
        </button>
        {hoverText && <div className="tooltip">{hoverText}</div>}
      </div>

      {sidebarOpen ? (
        <div className="dropdown-container">
          <CustomDropdown
            label="Session Type"
            options={[
              { value: "All", label: "All" },
              { value: "HR", label: "HR" },
              { value: "Sales", label: "Sales" },
              { value: "Marketing", label: "Marketing" },
              { value: "Engineering", label: "Engineering" }
            ]}
            value={selectedOption}
            
            onChange={handleOptionChange}
          />
        </div>
      ) : (
        <div className="icon-container" onClick={handleIconClick}>
          <i className="bi bi-person-lines-fill" style={{ fontSize: '24px', color: '#fff' }}></i> {/* Replace 'bi-gear-fill' with the icon of your choice */}
          {showOptions && (
            <div className="options-menu">
              <ul>
                <li onClick={() => setSelectedOption("All")}>All</li>
                <li onClick={() => setSelectedOption("HR")}>HR</li>
                <li onClick={() => setSelectedOption("Sales")}>Sales</li>
                <li onClick={() => setSelectedOption("Marketing")}>Marketing</li>
                <li onClick={() => setSelectedOption("Engineering")}>Engineering</li>
              </ul>
            </div>
          )}
        </div>
      )}

      <div onClick={newSession}>
        <button className={`newChat ${!sidebarOpen ? 'collapsed' : ''}`} style={{marginRight: '0px'}}>
          <i className={`bi ${sidebarOpen ? 'bi-plus-lg' : 'bi-plus-circle'}`} style={{ fontSize: '20px' }}></i> {/* Toggle between simple plus and circle plus based on sidebar state */}
          {sidebarOpen && (
            <div style={{ marginLeft: '8px'}}>
              New Chat Session
            </div>
          )}
        </button>
      </div>

      {sidebarOpen && (
        <>
          {/* <div className="dropdown-container">
            <select value={selectedOption} onChange={handleOptionChange} className="sidebar-dropdown">
              <option value="Option 1">HR</option>
              <option value="Option 2">Legal</option>
              <option value="Option 3">Finance</option>
              <option value="Option 3">ISMS</option>
            </select>
          </div> */}
        

          
            <div style={{display:'flex', flexDirection:'column', height:'69%'}}>
              <div className="chat-history-header">
                <h2 style={{ fontSize: '16px', fontWeight: '700', }}>Chat History</h2>
              </div>
               { chatHistory.length > 0 ? (
                <div className="chat-history-list" ref={chatHistoryListRef}>
                  {chatHistory.map((chat) => (
                    <div
                      key={chat.session_id}
                      onClick={() => handleClick(chat)} 
                      className={chat.session_id === selectedSession ? 'selected' : 'list-item'}
                      style={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}
                    >
                      <div>
                      <i className="bi bi-chat-left-text" style={{color:isDarkMode?'white':'black', fontSize:'16px', marginRight:'8px'}}></i>
                      {isEditing === chat.session_id?
                      <div>
                       <input
                          ref={inputRef}
                          type="text"
                          value={newSummary}
                          onChange={(e) => setNewSummary(e.target.value)} // Update state with input
                          onBlur={() => handleBlur(chat.session_id)} // Save on blur
                          onKeyDown={(e) => handleKeyDown(e, chat.session_id)} // Save on Enter
                          style={{
                            fontFamily: 'sans-serif',
                            fontWeight: '500',
                            fontSize: '14px',
                            lineHeight: '20px',
                            width: '100%',
                            padding: '2px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            backgroundColor: '#f0f0f0',
                          }}
                          autoFocus
                        />
                      </div>:
                      <span style={{fontFamily:'sans-serif', fontWeight:'500', fontSize:'14px', lineHeight:'20px'}}>
                        {(chat.summary) 
                         || 'Untitled Chat'}
                      </span>
                     }
                     </div>
                     <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                     onMouseEnter={() => toggleDropdown(chat.session_id)}  // Show on hover
                     onMouseLeave={() => toggleDropdown(null)} // Hide when mouse leaves
                     >
  <i 
    className="bi bi-three-dots-vertical"
    style={{ color: isDarkMode ? 'white' : 'black', cursor: 'pointer', borderRadius:'8px', padding:'2px' }}
    onMouseEnter={(e) => e.target.style.backgroundColor = isDarkMode ? '#0056b3' : '#E6E6FA'} // Hover state
    onMouseLeave={(e) => e.target.style.backgroundColor = isDarkMode ? '' : ''} // Hover out
  ></i>
  
  {dropdownVisibleFor === chat.session_id && (
  <div 
    ref={dropdownRef}
    style={{
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: isDarkMode ? '#1e1e1e' : '#fff', // Dark mode background
      border: isDarkMode ? '1px solid #555' : '1px solid #ddd', // Subtle border based on mode
      padding: '8px',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Light shadow for depth
      position: 'absolute',
      marginTop: `${dropdownPosition.marginTop}px`,
      left: '245px', // Adjusted for better positioning within sidebar
      zIndex: 1000, // Ensure dropdown is always on top
      width: '120px', // Fixed width for uniform appearance
      marginLeft:'0px'
    }}
  >
    <div
      className="dropdown-item"
      onClick={()=> handleRenameClick(chat.session_id, chat.summary)}
      style={{
        display:'flex',
        height:'40px',
        cursor: 'pointer',
        padding: '8px 12px',
        borderRadius: '4px',
        marginBottom: '8px',
        color: isDarkMode ? '#5E17EB' : '#5E17EB', // Text color contrast
        textAlign: 'center',
        flexDirection:'row',
        transition: 'background-color 0.3s ease',
      }}
      onMouseEnter={(e) => e.target.style.backgroundColor = isDarkMode ? '#2A2A2A' : '#E6E2F9'} // Hover state
      onMouseLeave={(e) => e.target.style.backgroundColor = isDarkMode ? '' : ''} // Hover out
    >
      <i className="bi bi-pencil-fill" style={{color: isDarkMode? '#E6E6FA':'#5e17eb',fontSize: '14px', marginRight:'8px' }}></i>
      <p style={{color: isDarkMode? '#fff':'#000'}}>Rename</p>
    </div>
    <div 
      className="dropdown-item" 
      onClick={() => handleDelete(chat.session_id)} 
      style={{
        display:'flex',
        height:'40px',
        flexDirection:'row',
        cursor: 'pointer',
        padding: '8px 12px',
        borderRadius: '4px',
        color: '#ff6666', // Text color contrast in dark mode
        textAlign: 'center',
        transition: 'background-color 0.3s ease',
      }}
      onMouseEnter={(e) => e.target.style.backgroundColor = isDarkMode ? '#2A2A2A' : '#E6E2F9'} // Hover state
      onMouseLeave={(e) => e.target.style.backgroundColor = isDarkMode ? '' : ''} // Hover out
    >
       <i className="bi bi-trash-fill" style={{ fontSize: '14px', marginRight:'8px' }}></i>
       <p style={{color: isDarkMode? '#fff':'#000'}}>Delete</p>
    </div>

  </div>
)}
</div>

{showConfirmation === chat.session_id && (
  <div
  ref={confirmationRef}
    style={{
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: isDarkMode ? '#1e1e1e' : '#fff', // Dark mode background
      border: isDarkMode ? '1px solid #555' : '1px solid #ddd', // Subtle border based on mode
      padding: '8px',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Light shadow for depth
      position: 'absolute',
     // Position just below the summary box
      left: '270px', // Align with the left of the summary box
      zIndex: 1000, // Ensure dropdown is always on top
      width: '250px', // Fixed width for uniform appearance
      marginTop: '0px', // Slight margin from the chat box
    }}
  >
    {/* Arrow on the left side */}
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '-10px', // Position the arrow under the three dots
        width: '0',
        transform: 'translateY(-50%)',
        height: '0',
        borderTop: '10px solid transparent',
        borderBottom: '10px solid transparent',
        borderRight: `10px solid ${isDarkMode ? '#1e1e1e' : '#D0D7DF'}`, // Arrow color
      }}
    ></div>

    <p style={{ fontWeight: '400', marginBottom: '10px', alignSelf:'center' }}>
      This will delete
    </p>
    <p style={{ marginBottom: '10px', alignSelf:'center' }}><strong>{chat.summary}</strong></p>
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <button
        onClick={confirmDelete}
        style={{
          backgroundColor: '#4caf50', // Green for confirm
          color: 'white',
          border: 'none',
          padding: '6px 15px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '12px',
          transition: 'background-color 0.3s ease', // Smooth hover transition
        }}
        onMouseEnter={(e) => (e.target.style.backgroundColor = '#388e3c')} // Darker green on hover
        onMouseLeave={(e) => (e.target.style.backgroundColor = '#4caf50')} // Original green on hover out
      >
        <i className="bi bi-check-circle" style={{ fontSize: '15px' }}></i>
      </button>
      <button
        onClick={() => setShowConfirmation(false)} // Close the confirmation
        style={{
          backgroundColor: '#f44336', // Red for cancel
          color: 'white',
          border: 'none',
          padding: '2px 13px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '12px',
          transition: 'background-color 0.3s ease', // Smooth hover transition
        }}
        onMouseEnter={(e) => (e.target.style.backgroundColor = '#d32f2f')} // Darker red on hover
        onMouseLeave={(e) => (e.target.style.backgroundColor = '#f44336')} // Original red on hover out
      >
        <i className="bi bi-x" style={{ fontSize: '21px' }}></i>
      </button>
    </div>
  </div>
)}


                     {/* {dropdownVisibleFor === chat.session_id && (
                       <div 
                        className="dropdown-menu"
                        style={{
                         position: 'absolute', 
                         right: 0, 
                         top: '20px', 
                         backgroundColor: isDarkMode ? '#333' : '#fff',
                         border: `1px solid ${isDarkMode ? '#555' : '#ccc'}`,
                         borderRadius: '4px',
                         padding: '8px',
                         zIndex: 1000
                       }}
                       >
                      <div 
                          className="dropdown-item" 
                          onClick={() => removeChat(chat.session_id)} 
                          style={{cursor: 'pointer', padding: '4px 8px'}}
                         >
                      Remove chat
                      </div>
                     </div>
                    )} */}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="message-box">
                    <i className="bi bi-info-circle"></i> Conversations not started yet.
                  </div>
                )}
              </div>
              
              <div onClick={handleDeleteChat} className={`deleteCov ${sidebarOpen ? 'sidebar-open' : 'sidebar-collapsed'}`}>
                <i className="bi bi-trash3-fill"></i>
                {sidebarOpen && (
                  <div style={{ marginLeft: '12px', fontSize: '14px', lineHeight: '20px'}}>
                    Clear Conversations
                  </div>
                )}
              </div>
        </>
      )}
    </div>
  );
};
export default Sidebar;